import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getHasPersonalizationAccess } from '../redux/selectors/authSelectors';
import { getHasPersonalizedVariants, getIsPersonalizedVariant } from '../redux/selectors/pageContentModelSelectors';
import { useFetchPersonalizationVariants } from './useFetchPersonalizationVariants';
import { VariantStatuses } from '../constants/PersonalizationVariants';
export const usePersonalizedPageUrl = ({
  contentId
}) => {
  const isPersonalizedVariant = useSelector(getIsPersonalizedVariant);
  const isPersonalizationDefault = useSelector(getHasPersonalizedVariants);
  const hasPersonalizationAccess = useSelector(getHasPersonalizationAccess);
  const {
    data
  } = useFetchPersonalizationVariants({
    contentId,
    shouldFetch: hasPersonalizationAccess && (isPersonalizedVariant || isPersonalizationDefault)
  });
  return useMemo(() => {
    const allVariants = (data === null || data === void 0 ? void 0 : data.personalizationVariants) || [];

    // An ABM variant publishes on its own URL, so prefer the URL of the
    // variant being edited. SMART_PAGE variants share the default page's URL
    // (their own is empty), so fall back to the default in that case.
    if (isPersonalizedVariant) {
      const currentVariant = allVariants.find(({
        id
      }) => Number(id) === Number(contentId));
      if (currentVariant !== null && currentVariant !== void 0 && currentVariant.publishedUrl) {
        return currentVariant.publishedUrl;
      }
    }
    const personalizationDefault = allVariants.find(({
      personalizationVariantStatus
    }) => personalizationVariantStatus === VariantStatuses.DEFAULT);
    return personalizationDefault === null || personalizationDefault === void 0 ? void 0 : personalizationDefault.publishedUrl;
  }, [data === null || data === void 0 ? void 0 : data.personalizationVariants, isPersonalizedVariant, contentId]);
};